import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DisplayService, Session } from 'src/app/my-sedgwick';
import { OutboundSsoService } from 'src/app/my-sedgwick/services/outbound-sso.service';
import { BaseComponent, MessageBus } from 'src/app/shared';
import { OutboundSSO } from 'src/app/shared/models/user';
import { InpageAliasService } from '../../../services/inpage-alias.service';
import { ConfigurationService } from '../../../services/configuration.service';
import { ConfigurationSetting } from '../../../../shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { LeaveLinkAccessService } from '../../../services/leavelink-access.service';
import { Aliases } from '../../../models/aliases';


@Component({
    selector: 'app-report-claim-card',
    template: `
    <app-panel
      class="tw-cursor-pointer"
      (click)="panelClick(); logPanelClick()"
      [shadow]="true"
      [attr.aria-label]="a"
      tabindex="-1"
      [canExpand]="false"
      [border]="'Empty'"
      >
      <div
        class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-bg-[var(--sed-warm-white-color)] tw-h-[425px] "
        >
        @if (canReport) {
          <h2
            class="tw-text-[26px] app-mt5 app-mb4 tw-font-light tw-text-center"
            role="heading"
            >
            {{ reportClaimLabel }}
          </h2>
          <div class="app-mb5">
            <img
              src="./assets/images/reportaclaim-image.png"
              height="250"
              width="150"
              alt=""
              role="icon"
              />
            </div>
            <div class="app-mb5">
              <app-button
                emphasis="High"
                [arialabel]="('Start ') + reportClaimLabel"
                label="Start"
                ></app-button
                >
              </div>
            } 
    
            @if (
              !canReport &&
              (this.outboundSSO === null ||
              this.outboundSSO[0].ssoLinkManager.trim() === '')
              ) {
              <h2 class="tw-text-[26px] app-mt5 app-mb4 tw-font-light">
                {{ 'Search claims' | translation: translationRequest }}
              </h2>
              <div class="app-mb5">
                <img
                  src="./assets/images/search-icon.png"
                  height="250"
                  width="150"
                  alt=""
                  />
                </div>
                <div class="app-mb5">
                  <app-button emphasis="High" label="Search">
                  </app-button>
                </div>
              }
    
              @if (
                showOnCards &&
                this.outboundSSO !== null &&
                this.outboundSSO[0].ssoLinkManager
                ) {
                <h2 class="tw-text-[26px] app-mt5 app-mb4 tw-font-light">
                  {{ outboundSSO[0].ssoLinkManager | translation: translationRequest }}
                </h2>
                <div class="app-mb5">
                  <img
                    src="./assets/images/search-icon.png"
                    height="250"
                    width="150"
                    alt=""
                    />
                  </div>
                  <div class="app-mb5"></div>
                }
              </div>
            </app-panel>
    `,
    styles: [``],
    standalone: false
})
export class ReportNewClaimCardComponent
  extends BaseComponent
  implements OnInit
{
  canReport = true;
  outboundSSO: OutboundSSO[];
  reportClaimLabel: string = '';
  
  ClientLevelConfig: ConfigurationSetting;
  a: string = 'a';
   
  get showOnCards(): boolean {
    const summaryviewsupervisor = this.config.getConfigFeatureAccess('summaryviewsupervisor');
    if (
      this.session?.user?.role.toUpperCase() == 'OMNI' ||
      this.session?.user?.role.toUpperCase() == 'OVERSEER' ||
      (this.session?.user?.role.toUpperCase() == 'SUPERVISOR' && summaryviewsupervisor
    )    
    ) {
      return true;
    } else {
      return false;
    }
  }

  @Input()
  translationRequest: TranslationRequest;
  
  constructor(
    private display: DisplayService,
    private router: Router,
    private messageBus: MessageBus,
    public outboundSsoService: OutboundSsoService,
    public claimConfigService: ConfigurationService,
    public inpageAliasService: InpageAliasService,
    private session: Session,
    private leaveLinkAccessService: LeaveLinkAccessService,
    public config: ConfigurationService
  ) {
    super();
    this.outboundSSO = this.display.outboundSSO;

    this.canReport = this.display.reportClaim && !this.outboundSSO;
  }

  async ngOnInit() {
    this.ClientLevelConfig =
      await this.claimConfigService.getAdditionalUserInformation();
      this.reportClaimLabel = await this.inpageAliasService.get('ReportClaim');
  }

  panelClick() {
    if (
      this.outboundSSO !== null &&
      this.outboundSSO[0].ssoLinkManager !== null &&
      this.outboundSSO[0].ssoLinkManager.trim() !== ''
    ) {
      if (this.outboundSSO[0].ssoType.toLowerCase() === 'leavelink') {
        this.handleLeaveLinkAccess();
      } else {
         this.outboundSsoService.showConfirmationDialog(
          this.outboundSSO[0].ssoType,
          this.outboundSSO[0].ssoEndPoint
        );       
      }
    } else if (this.canReport) {
      this.messageBus.publish('layout:report-claim');
    } else {
      this.router.navigate(['/search']);
    }
  }

  handleLeaveLinkAccess() {
    this.leaveLinkAccessService.handleLeaveLinkAccess();
  }

  logPanelClick() {
    if (
      this.outboundSSO !== null &&
      this.outboundSSO[0].ssoLinkManager !== null &&
      this.outboundSSO[0].ssoLinkManager.trim() !== ''
    ) {
      this.FeatureLogging(
        'ExternalSSO',
        this.outboundSSO[0].ssoLinkManager,
        'Summary View Card'
      );
    } else if (this.canReport) {
      this.FeatureLogging('ReportClaim', 'Report Claim', 'Summary View Card');
    } else {
      this.FeatureLogging('SearchClaims', 'Search Claims', 'Summary View Card');
    }
  }
}
